import { base } from './environment.base';

export const environment = {
    ...base,
    production: false,
    mode: 'development',
    encryptLocal: false,
    baseUrl: 'https://dev-ingagee.itechlabs.net/api/v1/ingagee',
};